<template>
  <div class="my-active-list">
    <!--头部开始 -->
    <top-part :rightPart="true">
      <template slot="difinePort">
        <van-dropdown-menu active-color="#29BEBC" :overlay="false" class="my-active-list1">
          <van-dropdown-item v-model="currentState" :options="statueList" @change="changVal()" />
        </van-dropdown-menu>
        <van-dropdown-menu active-color="#29BEBC" :overlay="false" class="my-active-list2">
          <van-dropdown-item v-model="value2" :options="option2" @change="changVal()" />
        </van-dropdown-menu>
      </template>
    </top-part>
    <!-- 头部结束 -->
    <!-- 福利列表开始 -->
    <div class="my-content" v-if="!noDate" ref="scollerList">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" immediate-check="false">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="welfare-list"
            v-for="(item,index) in dataList"
            :key="index"
            @click="openWelfareDetail(item)"
          >
            <div class="welfare-box">
              <span class="status-box" :class="gianClass(item.welfareState)">{{item.stateDefine}}</span>
              <img class="box-img1" :src="chargeImg(item.fileUrl)" />
            </div>
            <div class="text-box">
              <p class="wel-texP2">
                <img class="inform-icon" src="@/images/wel_text_icon.png" />
                <!-- <i class="van-ellipsis">{{item.welfareName}}</i> -->
                <i>{{item.welfareName}}</i>
              </p>
              <div class="text-bottom">
                <div style="flex: 1">
                  <span>领取时间：{{item.startTime}}至{{item.finishTime}}</span>
                </div>
                <div>
                  <span class="welfare-btn">{{item.free1}}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 福利列表结束 -->
    <!-- 无数据提示开始 -->
    <div v-if="noDate">
      <van-empty
        class="custom-image"
        :image="require('../../assets/images/null@2x.png')"
        description="暂无数据"
      />
    </div>
    <!-- 无数据提示结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import {
  getAppWelfareList,
  getActivityPrizesList,
  getUserInformation,
  delCookie
} from "@/common/api";
import { toast } from "@/common/api/api.js";
import moment from "moment";
import topPart from "../../components/topPart";
import welfareConfig from "../../centralControl/utils/welfareConfig";
export default {
  data() {
    return {
      dataList: [], //页面渲染的数据
      value2: "",
      currentState: "1", //福利状态
      option2: welfareConfig.typeList,
      welfareState: welfareConfig.welfareState,
      welFareFree1: welfareConfig.welFareFree1,
      statueList: welfareConfig.statueList,
      // welfareState: {
      //   //福利状态
      //   "0": "未开始",
      //   "1": "进行中",
      //   "2": "已结束"
      // },
      // welFareFree1: {
      //   //福利类型
      //   "1": "统一福利",
      //   "2": "自选福利"
      // },
      pageSize: 5,
      currentPage: 1,
      loading: false,
      finished: false,
      noDate: false,
      timeOut: "",
      refreshing: false,
      dataFinish: "",
      dataSum: "",
      scrollTop: 0,
      dateComplete: false
    };
  },
  components: {
    topPart
  },
  created() {
    this.init();
    let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
    getUserInformation({
      id: id
    }).then(res => {
      if (res.code == 200) {
        if (!res.data.status) {
          this.$createDialog({
            type: "alert",
            title: "提示",
            content: "登录失效,请重新登录",
            icon: "cubeic-alert",
            confirmBtn: {
              text: "退出",
              active: true,
              href: "javascript:;"
            },
            onConfirm: () => {
              window.localStorage.clear();
              delCookie("sessionId");
              this.$router.push("/login");
              window.location.reload();
            }
          }).show();
        }
      }
    });
  },
  activated() {
    // if (window.sessionStorage.getItem("scrollTop")) {
    //   this.scroll.scrollTo(
    //     0,
    //     Number(window.sessionStorage.getItem("scrollTop"))
    //   );
    //   this.scroll.refresh();
    //   // this.$refs['scollerList'].style.top  =window.sessionStorage.getItem('scrollTop')+ 'px'
    // }
  },
  //   beforeRouteLeave(to, from, next) {
  //     if (to.name === "login") {
  //       next({ name: "personalCenter" });
  //     } else {
  //       next(); // 注意：这边next必须要写
  //     }
  //   },
  methods: {
    // 福利的状态样式
    gianClass(state) {
      return state == "2" ? "status-end" : state == "0" ? "status-wait" : "";
    },
    // 把后端传来的数据进行转换
    eachangeName(attr) {
      for (let item of attr) {
        item.stateDefine = this.welfareState[item.welfareState]; // 把福利的状态从后端传来的value转为name
        item.free1 = this.welFareFree1[item.free1]; // 把福利的福利类型从后端传来的value转为name
        item.startTime = moment(item.startTime).format("YYYY-MM-DD"); // 把开始时间格式化
        item.finishTime = moment(item.finishTime).format("YYYY-MM-DD"); // 把结束时间格式化
      }
    },
    // 初始化函数
    init() {
      // this.gianListAll();
    },
    // 下拉框的值改变时触发
    changVal() {
      // this.value2 = val;
      this.dataList = [];
      this.noDate = false;
      this.finished = false;
      this.currentPage = 1;
      this.onLoad();
    },
    //获取福利全部数据
    gianListAll() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getWelfareList",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            // data.list[0].welfareState = "0";
            if (!data.list) {
              this.noDate = true;
              that.loading = false;
              return;
            }
            if (data.list.length == 0 && that.dataList.length == 0) {
              that.dataList = [];
              that.finished = true;
              that.noDate = true;
            }else {
              that.finished = false;
              that.noDate = false;
            }
            this.dataSum = res.data.sum;
            if (that.dataSum != "") {
              if (that.currentPage > Math.ceil(that.dataSum / that.pageSize)) {
                that.finished = true;
              }
            }
            that.dataList = [...that.dataList, ...data.list];
            this.eachangeName(data.list);
            that.loading = false;
            // that.currentPage++;
            console.log(that.dataList);
            console.log(data);
          } else {
            that.loading = false;
            this.noDate = true;
            that.finished = true;
            toast(this, message, "error");
          }
        },
        {
          free1: this.value2,
          welfareState: this.currentState,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          welfareCategory:'0'
        }
      );
    },
    //进入福利详情
    openWelfareDetail(option) {
      this.scrollTop = this.$refs.scollerList.offsetHeight;
      window.sessionStorage.setItem("scrollTop", this.scrollTop);
      this.$router.push({
        path: "/welfareDetail",
        query: {
          welfareId: option.welfareId,
          status: option.welfareState,
          free1: option.free1
        }
      });
    },
    // 判断福利数据没有图片时显示默认图片
    chargeImg(itemUrl) {
      return itemUrl
        ? itemUrl
        : require("../../assets/images/welfare_default_banner.png");
    },
    onLoad() {
      let that = this;
      let timer = setTimeout(() => {
        if (that.refreshing) {
          that.dataList = [];
          that.refreshing = false;
        }
        that.gianListAll();
        this.currentPage++;
        this.finished && clearTimeout(timer);
      }, 100);
    },
    onRefresh() {
      setTimeout(() => {
        // 清空列表数据
        this.finished = false;
        this.currentPage = 1;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      }, 1000);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/common.styl';

.van-dropdown-menu__bar {
  height: 44px;
}

.wel-texP2 {
  display: flex;
}

.my-content {
  myContent();
}

.welfare-list {
  margin: 10px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 1px 12px 0px rgba(212, 217, 226, 1);

  .inform-icon {
    width: 16px;
    height: 16px;
    vertical-align: bottom;
    margin-right: 0.08rem;
  }
}

.welfare-box {
  position: relative;

  .status-box {
    display: inline-block;
    color: #fff;
    padding: 6px 9px;
    position: absolute;
    top: 2.1vw;
    left: 4vw;
    font-size: 11px;
    background: linear-gradient(103deg, rgba(255, 19, 86, 1), rgba(255, 59, 142, 1), rgba(255, 19, 86, 1));
    border-radius: 4px;
  }

  .status-end {
    background: #000000;
    opacity: 0.5;
    border-radius: 4px;
  }

  .status-wait {
    background: linear-gradient(#4FACFE, #00F2FE);
    border-radius: 4px;
  }

  .box-img1 {
    width: 100%;
    height: 121px;
    border-radius: 16px 16px 0 0;
  }
}

.text-box {
  margin: 15px 20px 0;

  .text-bottom {
    font-size: 12px;
    padding-bottom: 15px;
    color: #ACACB7;
    display: flex;
    margin-top: 10px;

    .welfare-btn {
      color: $mainColor;
      border: 1px solid $mainColor;
      padding: 4px 10px;
      border-radius: 46px;
    }
  }

  i {
    color: #353535;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1px;
    // width: 64%;
    display: inline-block;
    font-family: PingFang SC;
    word-break: break-all;
    // line-height: 20px;
  }
}
</style>